export default __webpack_public_path__ + "static/media/compare_arrows_icon.495629bc.svg";